import { ICourse } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { SorterResult } from 'antd/lib/table/interface';
import { create as createStore } from 'zustand';

import { sdk } from '@/services';

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 10;

const CourseService = sdk.getService('CourseService');

interface IStore {
  page: number;
  limit: number;
  search: string;
  sort?: SorterResult<ICourse>;
  setSearch: (search: string) => void;
  setPageAndLimit: (page: number, limit: number) => void;
  setSort: (sort: SorterResult<ICourse>) => void;
}

const store = createStore<IStore>(set => ({
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
  search: '',
  setSearch: (search: string) => set(state => ({ ...state, search, page: INITIAL_PAGE })),
  setPageAndLimit: (page: number, limit: number) => set(state => ({ ...state, page, limit })),
  setSort: (sort: SorterResult<ICourse>) => set(state => ({ ...state, sort }))
}));

export const useBaseContentList = () => {
  const { page, limit, search, sort, setSearch, setPageAndLimit, setSort } = store();

  const queryKey = ['courses', 'base-content', `page-${page}`, `limit-${limit}`, search, sort];

  const { isLoading, data, error } = useQuery({
    queryKey,
    queryFn: () => CourseService.findAllBaseContent(search, { page, limit }, sort)
  });

  const resetSearchResults = () => setSearch('');

  const pagination = data && {
    page: data.page,
    limit: data.limit,
    hasNextPage: data.hasNextPage,
    hasPrevPage: data.hasPrevPage,
    nextPage: data.nextPage,
    pagingCounter: data.pagingCounter,
    prevPage: data.prevPage,
    totalDocs: data.totalDocs,
    totalPages: data.totalPages
  };

  return {
    courses: data?.docs,
    isLoading,
    error,
    setPageAndLimit,
    pagination,
    setSearch,
    setSort,
    search,
    resetSearchResults
  };
};
